import ArticleTeaser from './ArticleTeaser';
export * from './ArticleTeaser';
export default ArticleTeaser;
